import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const typographyVariants = cva("font-sans", {
  variants: {
    variant: {
      default: "font-sans",
      subHeadingSm: "text-base leading-[140%] md:leading-[150%]",
      subHeadingLg:
        "text-xl leading-[135%] lg:text-2xl lg:leading-[150%] lg:font-medium",
      subHeadingMd: "text-lg leading-[135%] lg:text-2xl lg:leading-[150%]",
      headingMain:
        "text-[40px] leading-[120%] font-semibold lg:text-[54px]/20 lg:font-medium lg:leading-[135%]",
      heading4:
        "text-[32px] leading-[120%] lg:text-[40px] lg:leading-[150%] font-semibold md:font-medium text-gray-800",
      headingFixed4: "text-[32px] leading-[120%]",
      heading5:
        "text-2xl leading-[120%] lg:text-[36px] lg:leading-[150%] font-semibold md:font-normal",
      headingFixed5: "text-2xl leading-[120%] font-semibold",
      titleLg:
        "text-[24px] leading-[130%] lg:text-[40px] lg:leading-[150%] font-medium",
      titleMd: "text-xl leading-[130%] font-medium",
      titleSm:
        "text-lg leading-[130%] lg:text-base lg:leading-[150%] font-medium",
      titleFixedSm: "text-lg leading-[130%]",
      labelMd: "text-base leading-[130%] lg:text-[14px] lg:leading-[150%]",
      labelFixedMd: "text-base leading-[130%]",
      labelFixedLg: "text-lg leading-[130%]",
      labelSm: "text-sm leading-[130%]",
      bodyLg: "text-lg leading-[135%] lg:text-xl lg:leading-[150%]",
      caption: "text-[12px] leading-[150%]",
      captionLg: "text-sm leading-[150%] font-medium",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const Typography = ({
  asChild,
  variant,
  className,
  ...rest
}: React.ComponentProps<"div"> &
  VariantProps<typeof typographyVariants> & {
    asChild?: boolean;
  }) => {
  const Component = asChild ? Slot : "div";

  return (
    <Component
      {...rest}
      className={cn(typographyVariants({ variant, className }))}
    />
  );
};

export { Typography, typographyVariants };
